<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>任务计划地图</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="left">
        <MapCom :pointInfo="pointInfo"></MapCom>
        <div class="tl-box">
          <div class="tl-box-item">
            <img src="@/assets/image/dadianB.png" alt="" />
            <span>普通点位</span>
          </div>
          <div class="tl-box-item">
            <img src="@/assets/image/dadianA.png" alt="" />
            <span>应急点位</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">任务列表</div>
        <div class="select-box">
          <el-select
            style="flex:1;margin-right: 8px;"
            placeholder="请选择是否督办"
            clearable
            v-model="overseeFlag"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <el-select
            style="flex:1;margin-right: 8px;"
            placeholder="是否应急任务"
            clearable
            v-model="taskLevel"
          >
            <el-option label="是" value="应急"></el-option>
            <el-option label="否" value="一般"></el-option>
          </el-select>
        </div>
        <div class="list-box">
          <div
            class="list-box-item"
            v-for="(item, index) in listData"
            :key="index"
          >
            <div class="item-title">{{ item.eventName }}</div>
            <div class="item-flex-box">
              <div
                class="item-flex-box-item time"
                v-if="item.hasHour && item.hasHour < 0"
              >
                超时
              </div>
              <div
                class="item-flex-box-item time"
                v-if="item.hasHour && item.hasHour >= 0"
              >
                剩余{{ item.hasHour }}小时
              </div>
              <div class="item-flex-box-item type">
                {{ item.eventTypeName }}
              </div>
              <img
                v-if="item.taskLevel == '应急'"
                class="item-flex-box-item"
                src="@/assets/image/yj.png"
                alt=""
              />
              <img
                v-if="item.overseeFlag == 1"
                class="item-flex-box-item"
                src="@/assets/image/db.png"
                alt=""
              />
            </div>
            <div class="info-box">
              <img class="info-box-item" src="@/assets/image/wz.png" alt="" />
              <div style="white-space: nowrap;" class="info-box-item">点位</div>
              <div class="info-box-item value">
                {{ item.pointName }}
              </div>
            </div>
            <div class="info-box">
              <img class="info-box-item" src="@/assets/image/sj.png" alt="" />
              <div style="white-space: nowrap;" class="info-box-item">
                任务下达时间
              </div>
              <div class="info-box-item value">
                {{ item.taskRuleCreatetime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MapCom from "./components/map.vue";
import { pointPlanPic, taskPage } from "@/api/task.js";
export default {
  components: { MapCom },
  data() {
    return {
      pointInfo: {},
      overseeFlag: "",
      taskLevel: "",
      listData: []
    };
  },
  mounted() {
    this.taskPageFun();
    this.pointPlanPicFun();
  },
  methods: {
    async pointPlanPicFun() {
      const res = await pointPlanPic();
      this.pointInfo = res.data.data;
    },
    async taskPageFun() {
      const res = await taskPage({
        searchSource: "PC_MANAGE",
        page: 1,
        size: 999999,
        overseeFlag: this.overseeFlag,
        taskLevel: this.taskLevel
      });
      this.listData = res.data.data.records || [];
    }
  },
  watch: {
    overseeFlag() {
      this.taskPageFun();
    },
    taskLevel() {
      this.taskPageFun();
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.box-father .section {
  display: flex;
  padding: 0;
  .left {
    height: 100%;
    width: calc(100% - 402px);
    position: relative;
    .tl-box {
      position: absolute;
      left: 24px;
      bottom: 16px;
      width: 140px;
      height: 116px;
      background: #ffffff;
      box-shadow: -3px 3px 8px 0px rgba(22, 54, 79, 0.1);
      border-radius: 8px;
      z-index: 9999;
      padding: 24px 20px;
      .tl-box-item {
        display: flex;
        align-items: center;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #494c4f;
        img {
          height: 24px;
          margin-right: 8px;
        }
      }
      .tl-box-item:first-child {
        margin-bottom: 22px;
      }
    }
  }
  .right {
    height: 100%;
    width: 402px;
    padding: 28px 24px;
    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
    .select-box {
      display: flex;
      align-items: center;
    }
    .list-box {
      height: calc(100% - 80px);
      overflow: auto;
      .list-box-item {
        padding: 23px 0;
        border-bottom: 1px solid #e0e0e0;
        .item-title {
          font-family: MiSans, MiSans;
          font-weight: 700;
          font-size: 24px;
          color: #494c4f;
          margin-bottom: 10px;
        }
        .item-flex-box {
          display: flex;
          align-items: center;
          .item-flex-box-item {
            margin-right: 8px;
          }
          img {
            height: 24px;
          }
          .time {
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #eb3538;
            padding: 1px 8px;
            background: rgba(235, 53, 56, 0.1);
            border-radius: 4px;
          }
          .type {
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #0090ff;
            padding: 1px 8px;
            background: rgba(0, 144, 255, 0.1);
            border-radius: 4px;
          }
        }
        .info-box {
          display: flex;
          align-items: center;
          margin-top: 12px;
          img {
            height: 22px;
          }
          .info-box-item {
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #92979c;
            margin-right: 8px;
          }
          .value {
            font-family: MiSans, MiSans;
            font-weight: 400;
            font-size: 16px;
            color: #494c4f;
          }
        }
      }
    }
  }
}
.box-father {
  padding-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskPlanMap/index.vue